/**
 * MultiFileUpload - A class for handling visibility of upload fields
 */
class MultiFileUpload {
	/**
	 * Setup method
	 * Static method to set up the class on the page
	 *
	 * @return {void}
	 */
	static setup() {
		const elements = document.querySelectorAll('.single-product .qte-product-info-section form');

		for (const element of elements) {
			const instance = new MultiFileUpload(element);
			instance.init();
		}
	}

	/**
	 * Constructor method
	 *
	 * @param {HTMLElement} element
	 * @return {void}
	 */
	constructor(element) {
		this.form = element;
		this.uploadFields = Array.from(this.form.querySelectorAll('.main_upload'));
	}

	/**
	 * Initialize method
	 * Method to initialize a class instance
	 */
	init() {
		this.uploadFields.forEach((uploadField, index) => {
			const inputField = uploadField.querySelector('.fme_upload_file');
			inputField.addEventListener('input', (e) => this.handleUploadField(e, index));
		});
	}

	/**
	 * handleUploadField
	 * Adds the 'show' class to the next field if a file is selected and removes it if no files are selected
	 *
	 * @param {Event} e
	 * @param {number} index - The index of the current upload field
	 * @return {void}
	 */
	handleUploadField(e, index) {
		const nextUploadField = this.uploadFields[index + 1];

		// If files are present in the current field, show the next field
		if (e.target.files.length > 0) {
			if (nextUploadField) {
				nextUploadField.classList.add('show');
			}
		} else if (nextUploadField) {
			// Remove 'show' from next field if no files are selected
			nextUploadField.classList.remove('show');
		}
	}
}

// The document is checked if it is ready. If it is, the setup() method is called.
if (document.readyState === 'interactive' || document.readyState === 'complete') {
	MultiFileUpload.setup();
} else {
	document.addEventListener('DOMContentLoaded', MultiFileUpload.setup);
}
